import { createSlice } from "@reduxjs/toolkit";

const MAX_ITEMS = 100;

const notificationSlice = createSlice({
  name: "notifications",
  initialState: {
    items: [],
    readIds: [],
  },
  reducers: {
    addNotifications(state, action) {
      const existingIds = new Set(state.items.map((n) => n.id));
      const uniqueNewOnes = action.payload.filter(
        (n) => !existingIds.has(n.id),
      );
      if (uniqueNewOnes.length === 0) return;
      state.items = [...uniqueNewOnes, ...state.items].slice(0, MAX_ITEMS);
      const validIds = new Set(state.items.map((n) => n.id));
      state.readIds = state.readIds.filter((id) => validIds.has(id));
    },
    markAsRead(state, action) {
      if (!state.readIds.includes(action.payload)) {
        state.readIds.push(action.payload);
      }
    },
    markAllAsRead(state) {
      state.readIds = state.items.map((n) => n.id);
    },
    clearAll(state) {
      state.items = [];
      state.readIds = [];
    },
  },
});

export const { addNotifications, markAsRead, markAllAsRead, clearAll } =
  notificationSlice.actions;

export default notificationSlice.reducer;